import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SelectModule } from "ng-select";
import { BsDatepickerModule, TooltipModule } from "ngx-bootstrap";
import { FilterProductsModule } from "../../../../layout/filter-products/filter-products.module";
import { Select2ApiModule } from "../share/select2Api/select2Api.module";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
    FilterProductsModule,
    Select2ApiModule,
  ],
  exports: [],
  declarations: [],
})
export class ImportCratingModule {}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/import-crating/import-crating.module.ts